import store from "@/store"

export default function superadminAccountManager({ next, router }) {
    if(!store || !store.state.auth.isLogged || !['superadmin', 'supermanager', 'account_manager'].includes(store.state.auth.user.role)) {
        router.push('/admin/login')
        return
    }
    return next()
}
